import { useAuth, useLocale } from 'shared-ui';

import { AppRoute } from 'routing/AppRoute.enum';
import { AppMessages } from 'i18n/messages';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

export type DefinitionBarRoute = {
  path:
    | AppRoute.definitions
    | AppRoute.positions
    | AppRoute.eventsExportFormats
    | AppRoute.ownersControl
    | AppRoute.display
    | AppRoute.logotype
    | AppRoute.sequencesTerminals
    | AppRoute.passwordPolicy
    | AppRoute.mailAccount
    | AppRoute.automation
    | AppRoute.zones
    | AppRoute.passages;
  label: string;
  isVisible: boolean;
};

export const useTopBarRoutes = () => {
  const { formatMessage } = useLocale();
  const { isAdmin } = useAuth();
  const { perms } = usePermissions();

  const routes: Record<
    | 'definitions'
    | 'positions'
    | 'events'
    | 'control'
    | 'display'
    | 'logotype'
    | 'sequences'
    | 'passwordPolicy'
    | 'mailAccount'
    | 'automation'
    | 'zones'
    | 'passages',
    DefinitionBarRoute
  > = {
    definitions: {
      path: AppRoute.definitions,
      label: formatMessage({ id: AppMessages['definitions.organization'] }),
      isVisible: true,
    },
    positions: {
      path: AppRoute.positions,
      label: formatMessage({ id: AppMessages['definitions.positions'] }),
      isVisible: true,
    },
    events: {
      path: AppRoute.eventsExportFormats,
      label: formatMessage({ id: AppMessages['definitions.events'] }),
      isVisible: isAdmin,
    },
    control: {
      path: AppRoute.ownersControl,
      label: formatMessage({ id: AppMessages['definitions.control'] }),
      isVisible: true,
    },
    display: {
      path: AppRoute.display,
      label: formatMessage({ id: AppMessages['definitions.display.title'] }),
      isVisible: true,
    },
    logotype: {
      path: AppRoute.logotype,
      label: formatMessage({ id: AppMessages['definitions.logotype.title'] }),
      isVisible: true,
    },
    sequences: {
      path: AppRoute.sequencesTerminals,
      label: formatMessage({ id: AppMessages['definitions.sequences.title'] }),
      isVisible: true,
    },
    passwordPolicy: {
      path: AppRoute.passwordPolicy,
      label: formatMessage({ id: AppMessages['definitions.passwordPolicy.title'] }),
      isVisible: true,
    },
    mailAccount: {
      path: AppRoute.mailAccount,
      label: formatMessage({ id: AppMessages['definitions.mailAccount.title'] }),
      isVisible: true,
    },
    automation: {
      path: AppRoute.automation,
      label: formatMessage({ id: AppMessages['definitions.automation'] }),
      isVisible: !!perms?.DEFINICJE?.view,
    },
    zones: {
      path: AppRoute.zones,
      label: formatMessage({ id: AppMessages['definitions.zones'] }),
      isVisible: true,
    },
    passages: {
      path: AppRoute.passages,
      label: formatMessage({ id: AppMessages['definitions.passages'] }),
      isVisible: true,
    },
  };

  return { routes };
};
